{
	"language": {
		"select": "Seleccionar idioma",
		"sectionTitle": "Idioma",
		"changeSuccess": "El idioma se cambió correctamente"
	},
	"assistant": {
		"composer": {
			"placeholder": "Pregunta a {{assistantName}}",
			"disclaimer": "{{assistantName}} puede cometer errores. Verifica la información importante."
		},
		"greeting": {
			"initialMessage": "👋 ¡Hola! Soy el asistente de aprendizaje **{{assistantName}}** y estoy aquí para ayudarte a prepararte mejor para **{{context}}.** Analicemos específicamente el ítem que respondiste sobre **{{topic}}.**",
			"starter": "¡Hola! Soy **{{assistantName}}**. ¿En qué puedo ayudarte?"
		},
		"chips": {
			"askYourOwn": "Haz tu propia pregunta",
			"askFollowUp": "Haz una pregunta de seguimiento"
		},
		"emptyState": {
			"title": "{{assistantName}} es tu asistente de aprendizaje con IA",
			"contextSubtitle": "Pregunta lo que quieras sobre {{context}}",
			"activateSubtitle": "{{assistantName}} se activará después de que respondas la pregunta"
		}
	},
	"dashboard": {
		"header": {
			"quickStudy": "Estudio rápido",
			"examInfo": {
				"subtitle": {
					"setExamDate": "Establece una fecha de examen para recibir mejores recomendaciones.",
					"examDateWithValue": "Fecha del examen: <date>{{date}}</date>"
				}
			}
		},
		"reviewPrompt": {
			"buttons": {
				"couldBeBetter": "Podría mejorar",
				"itsAwesome": "Es excelente"
			},
			"title": "¡Vas muy bien!",
			"body": "¡Nos entusiasma ver tu dedicación al estudio! ¿Cómo ha sido tu experiencia con la app hasta ahora? ¿Podrías compartir tu opinión en una reseña?",
			"cta": "Quizá más tarde"
		},
		"actions": {
			"studyWeak": "Reforzar áreas débiles",
			"viewProgress": "Ver tu progreso",
			"seeRank": "Consultar tu posición",
			"seeRankings": "Ver clasificación",
			"unlock": "Desbloquear contenido premium",
			"unlockTooltip": "Obtén acceso a funciones exclusivas y materiales de estudio avanzados al desbloquear el contenido premium",
			"startCustomSession": "Crear una sesión personalizada",
			"startCustomSessionTooltip": "Inicia una sesión de estudio personalizada para enfocarte en áreas específicas",
			"takeDiagnostic": "Realizar diagnóstico",
			"takeDiagnosticTooltip": "Realiza un diagnóstico para evaluar tu nivel actual y adaptar tu plan de estudio",
			"viewDiagnostic": "Ver resultados del diagnóstico",
			"viewDiagnosticTooltip": "Consulta los resultados de tu diagnóstico para conocer tus fortalezas y áreas de mejora",
			"viewPodcasts": "Escuchar podcasts",
			"viewPodcastsTooltip": "Accede a podcasts educativos para enriquecer tu aprendizaje",
			"upgradeToPremium": "Obtener premium",
			"upgradeToPremiumTooltip": "Cámbiate a premium para acceder a todo el contenido y las funciones",
			"extendAccess": "Extender acceso",
			"extendAccessTooltip": "Extiende tu acceso al contenido y las funciones premium",
			"setExamDate": "Establecer fecha del examen",
			"setExamDateTooltip": "Establece la fecha de tu examen para dar seguimiento a tu progreso y prepararte"
		},
		"exam": {
			"daysAgo_one": "Hace {{count}} día",
			"daysAgo_other": "Hace {{count}} días",
			"untilExam_one": "{{count}} día para el examen",
			"untilExam_other": "{{count}} días para el examen",
			"isToday": "¡El examen es hoy!"
		},
		"stats": {
			"mastery": "Dominio",
			"completed_one": "Reactivo respondido",
			"completed_other": "Reactivos respondidos",
			"completedValue": "{{count}}",
			"xpEarned": "XP obtenidos",
			"xpEarnedValue": "{{value}}",
			"accuracy": "Precisión",
			"accuracyValue": "{{value}}%",
			"skillLevelTooltip": "Tu dominio estimado de {{skill, lowercase}} es {{level, lowercase}}",
			"itemsAnsweredTooltip": "Número total de reactivos que has respondido hasta ahora",
			"responsesAnsweredTooltip": "Número total de respuestas que has enviado hasta ahora",
			"examDateTooltip": "Tu examen es el {{date}}",
			"skillCta": {
				"diagnostic": "Diagnóstico",
				"practice": "Practicar"
			}
		},
		"menu": {
			"settings": "Configuración",
			"profile": "Perfil"
		},
		"diagnostics": {
			"title": "Diagnósticos",
			"free": "Gratis",
			"duration": "{{count}} {{item}} • {{minutes}} min",
			"completed": "{{count}} {{item}} completados",
			"start": "Comenzar",
			"viewReport": "Ver reporte",
			"resume": "Reanudar"
		},
		"practiceTests": {
			"title": "Exámenes de práctica",
			"sectionalTestsTitle": "Exámenes seccionales",
			"diagnosticAssessmentsTitle": "Evaluaciones diagnósticas",
			"premiumChipTooltip": "Exámenes de práctica completos premium para el examen {{examName}}",
			"freeChipTooltip": "{{label}} para el examen {{examName}}",
			"freeChipTooltipDefault": "Evaluaciones diagnósticas gratuitas para el examen {{examName}}",
			"completedDescription_one": "{{count}} reactivo • {{date}}",
			"completedDescription_other": "{{count}} reactivos • {{date}}",
			"activeDescription_one": "{{attempted}}/{{count}} reactivo • {{timeRemaining}} restantes",
			"activeDescription_other": "{{attempted}}/{{count}} reactivos • {{timeRemaining}} restantes",
			"activeDescriptionWithDates_one": "{{attempted}}/{{count}} reactivo • {{timeRemaining}} restantes • Iniciado el: {{startedOn}} • Finaliza el: {{endsOn}}",
			"activeDescriptionWithDates_other": "{{attempted}}/{{count}} reactivos • {{timeRemaining}} restantes • Iniciado el: {{startedOn}} • Finaliza el: {{endsOn}}",
			"notStartedDescription_one": "{{count}} reactivo • {{duration}}",
			"notStartedDescription_other": "{{count}} reactivos • {{duration}}",
			"notStartedDescriptionWithEnd_one": "{{count}} reactivo • {{duration}} • Finaliza el: {{endsOn}}",
			"notStartedDescriptionWithEnd_other": "{{count}} reactivos • {{duration}} • Finaliza el: {{endsOn}}",
			"viewResultsCta": "Ver resultados",
			"startCta": "Comenzar",
			"chips": {
				"items_one": "{{count}} reactivo",
				"items_other": "{{count}} reactivos",
				"progress_one": "{{attempted}}/{{count}} reactivo",
				"progress_other": "{{attempted}}/{{count}} reactivos",
				"timeRemaining": "{{time}} restantes",
				"startedOn": "Iniciado el: {{date}}",
				"endsOn": "Finaliza el: {{date}}",
				"timeLeft": "{{time}} restantes"
			},
			"status": {
				"notStarted": {
					"label": "No iniciado",
					"section": "Exámenes de práctica completos"
				},
				"inProgress": {
					"label": "En curso",
					"section": "En curso"
				},
				"completed": {
					"label": "Completado",
					"section": "Completado"
				},
				"legacyReports": {
					"label": "Informes heredados",
					"section": "Informes heredados"
				},
				"migratedReports": {
					"label": "Informes migrados",
					"section": "Informes migrados"
				}
			}
		},
		"skills": {
			"title": "Habilidades",
			"unlockSubtitle": "Desbloquea premium para practicar",
			"startCta": "Practicar",
			"freeItemsIncludedChip": "Reactivos gratis incluidos",
			"freeItemsAnsweredSubtitle_one": "{{answered, number}} de {{count, number}} reactivo gratis respondido",
			"freeItemsAnsweredSubtitle_other": "{{answered, number}} de {{count, number}} reactivos gratis respondidos",
			"progressCards": {
				"questionTypesTitle": "Desempeño por tipo de pregunta",
				"questionTypesSubtitle": "Tus resultados en los tipos de pregunta de {{skill}}",
				"proficiencyTitle": "Desempeño por nivel de competencia",
				"proficiencySubtitle": "Tu progreso en los niveles de {{skill}}",
				"questionTypeCardSubtitle": "Progreso por nivel de competencia",
				"bySkillTitle": "Desempeño por habilidad",
				"bySkillSubtitle": "Progreso general en las habilidades",
				"needsImprovementTitle": "Necesita mejorar",
				"needsImprovementSubtitle": "Habilidades que debes reforzar",
				"skillPerformanceTitle": "Desempeño en {{skill}}",
				"skillPerformanceSubtitle": "Progreso por tipo de pregunta y nivel de competencia",
				"skillLevelSubtitle": "Tu progreso en este nivel de habilidad",
				"skillsPerformanceTitle": "Desempeño en habilidades",
				"performanceByItemDifficulty": "Desempeño por nivel de competencia del reactivo",
				"performanceByItemDifficultyCaption_one": "Muestra tu precisión por nivel de competencia, con base en {{count}} reactivo intentado",
				"performanceByItemDifficultyCaption_other": "Muestra tu precisión por nivel de competencia, con base en {{count}} reactivos intentados",
				"questionTypePartSubtitle": "{{skill}} · Parte {{part}}",
				"activityGoalTitle": "Actividad y progreso de la meta",
				"recentActivityTitle": "Actividad reciente",
				"goalProgressTitle": "Progreso de la meta",
				"goalProgressSubtitle": "Puntuación general · Últimas 7 semanas",
				"goalProgressInsight": "Estás mejorando de forma constante. Te faltan 14 puntos para alcanzar tu objetivo y podrías lograrlo en unas 3 semanas.",
				"goalProgressActualLabel": "Tu puntuación",
				"goalProgressTargetLabel": "Objetivo",
				"goalProgressTimeAxisLabel": "Tiempo",
				"goalProgressScoreAxisLabel": "Progreso general",
				"statusTitle": "Tu estado",
				"diagnosticsTitle": "Diagnósticos",
				"diagnosticsReviewCta": "Revisar",
				"strengthsFocusTitle": "Fortalezas y áreas de enfoque",
				"strengthsFocusSubtitle": "Tus áreas más sólidas y los tipos de pregunta que requieren más práctica",
				"strengthsLabel": "Fortalezas",
				"focusAreasLabel": "Áreas de enfoque",
				"recommendedNextStepLabel": "Siguiente paso recomendado",
				"recommendedNextStepCta": "Comenzar",
				"practiceTestsViewMore": "Ver los {{count}} exámenes"
			},
			"proficiencySection": "Practicar por nivel de competencia"
		},
		"recommendedTasks": {
			"sectionTitle": "Recomendado para ti",
			"startSessionAction": "Practicar",
			"resumeAction": "Continuar",
			"reviewResultsAction": "Revisar resultados",
			"startTestAction": "Comenzar",
			"activeTestBody": "Completa tu evaluación en curso",
			"completedTestBody": "Revisa tu desempeño y tus respuestas",
			"diagnosticBody": "Realiza {{label}} para familiarizarte con el formato del examen",
			"diagnosticDefaultLabel": "un diagnóstico gratuito",
			"practiceTestBody": "Evalúa qué tan preparado estás para el examen con un examen cronometrado.",
			"sectionalTestBody": "Haz un examen enfocado para practicar tus habilidades de {{skills}}.",
			"weakSkillTitle": "Mejora tu {{skill}}",
			"weakSkillBody": "Práctica de {{questionType}}, priorizando lo que aún no dominas.",
			"strongSkillTitle": "Mantén afilado tu {{skill}}",
			"strongSkillBody": "Vas bien aquí. Un set rápido de {{questionType}} te ayuda a mantenerlo.",
			"mixedSkillTitle": "Complementa tu {{skill}}",
			"mixedSkillBody": "Un set mixto de {{questionTypes}}, priorizando lo que has fallado.",
			"higherDifficultySkillTitle": "Sube a {{proficiency}}",
			"higherDifficultySkillBody": "Ya manejas {{questionType}} a este nivel. Estos van un poco más difíciles.",
			"itemsChip_one": "{{count}} reactivo",
			"itemsChip_other": "{{count}} reactivos",
			"timeRemainingChip": "{{minutes}} min restantes",
			"timeRemainingChipCompact": "{{minutes}} min"
		},
		"itemTypes": {
			"answeredLabel_one": "Reactivo respondido",
			"answeredLabel_other": "Reactivos respondidos",
			"answeredAll": "Todos",
			"answeredPartial": "{{answered}} de {{total}}",
			"cardSubtitleResponses_one": "{{count}} respuesta",
			"cardSubtitleResponses_other": "{{count}} respuestas",
			"responsesLabel_one": "Respuesta",
			"responsesLabel_other": "Respuestas",
			"cardSubtitleComplete": "Todos los reactivos respondidos",
			"cardSubtitlePartial": "{{attempted}} de {{total}} reactivos respondidos",
			"detail": {
				"skillLabel": "Habilidad",
				"estimatedLevelLabel": "Nivel estimado"
			}
		},
		"tagSections": {
			"summary": "{{tagCount, number}} {{label, lowercase}} • $t(common.itemCount, {\"count\": {{itemCount}} })",
			"summaryWithoutItemCount": "{{tagCount, number}} {{label, lowercase}}",
			"responseCount_one": "{{count, number}} respuesta",
			"responseCount_other": "{{count, number}} respuestas"
		},
		"studyPack": {
			"freeContentBannerTitle_one": "{{count, number}} reactivo de práctica incluido gratis",
			"freeContentBannerTitle_other": "{{count, number}} reactivos de práctica incluidos gratis",
			"freeContentBannerBody": "Practica los reactivos de {{skills}} cuando quieras. Mejora tu plan para desbloquear el Paquete de estudio completo.",
			"freeContentBannerCta": "Iniciar práctica gratis"
		}
	},
	"appbar": {
		"leaderboard": {
			"description": "Compara tu desempeño con el de otras personas"
		},
		"home": {
			"title": "Inicio"
		},
		"podcasts": {
			"description": "Escucha podcasts de ortopedia dirigidos por especialistas."
		},
		"more": {
			"title": "Más opciones"
		}
	},
	"emptyState": {
		"progress": {
			"title": "Aún no hay progreso de estudio",
			"subtitle": "Tu progreso aparecerá aquí conforme estudies",
			"cta": "Estudiar ahora"
		}
	},
	"errors": {
		"sessionCreation": {
			"title": "Error",
			"body": "No se pudo crear la sesión. Inténtalo de nuevo"
		}
	},
	"mastery": {
		"labels": {
			"advanced": "Avanzado",
			"highIntermediate": "Intermedio",
			"intermediate": "Intermedio",
			"basic": "Básico",
			"none": "Sin responder",
			"high": "Dominado",
			"medium": "Casi lo logras",
			"low": "Necesita mejorar"
		}
	},
	"leaderboard": {
		"you": "Esta es tu posición",
		"periods": {
			"all_time": "Todo el tiempo",
			"month": "Este mes",
			"week": "Esta semana"
		},
		"scope": {
			"global": "Global",
			"friends": "Amigos"
		},
		"friends": {
			"soon": "PRÓXIMAMENTE",
			"comingSoonTitle": "Clasificación de amigos",
			"comingSoonBadge": "Próximamente",
			"comingSoonDescription": "Compara tu progreso con el de tus amigos y descubre quién ocupa el primer lugar de la clase."
		},
		"error": {
			"title": "Error de conexión",
			"description": "No se pudo cargar la clasificación. Revisa tu conexión e inténtalo de nuevo.",
			"tryAgain": "Intentar de nuevo"
		},
		"empty": {
			"title": "Aún no hay posiciones",
			"description": "Sé la primera persona en comenzar a aprender y ocupa el primer lugar de la clasificación.",
			"startLearning": "Comenzar a aprender"
		},
		"topPerformers": "Mejores participantes",
		"yourPosition": "Tu posición",
		"rankings": "Clasificación",
		"rankingsRange": "Clasificación • #{{startRank}}–{{endRank}}",
		"unranked": {
			"title": "¡Obtén XP para entrar en la clasificación!",
			"description": "Inicia una sesión de estudio para obtener tus primeros puntos y entrar en la clasificación.",
			"cta": "Iniciar tu primera sesión"
		},
		"xpAmount": "<num>{{value}}</num> <unit>XP</unit>",
		"youBadge": "TÚ",
		"podium": {
			"first": "1.º",
			"second": "2.º",
			"third": "3.º"
		},
		"footer": {
			"gapHintToPass": "<num>+{{value}}</num><unit> XP</unit> <rest>para superar el puesto #{{rank}}</rest>",
			"gapHintFromPodium": "<num>+{{value}}</num><unit> XP</unit> <rest>para llegar al podio</rest>"
		}
	},
	"lessons": {
		"explore": {
			"title": "Lecciones",
			"searchPlaceholder": "Buscar lecciones",
			"count_one": "{{count}} lección",
			"count_other": "{{count}} lecciones",
			"sortModalTitle": "Ordenar lecciones",
			"filterModalTitle": "Filtrar por temas",
			"sort": {
				"popularity": "Popularidad",
				"popularityShort": "Popular",
				"topic": "Tema",
				"difficulty": "Dificultad",
				"recent": "Actualizado recientemente",
				"recentShort": "Actualizado",
				"completed": "Completado"
			},
			"chips": {
				"all": "Todas",
				"recent": "Actualizadas recientemente",
				"completed": "Completadas",
				"premium": "Premium",
				"topics": "Temas",
				"topicsCount_one": "{{count}} tema",
				"topicsCount_other": "{{count}} temas"
			},
			"chipTooltips": {
				"all": "Muestra todas las lecciones.",
				"recent": "Muestra las lecciones actualizadas recientemente.",
				"completed": "Muestra las lecciones completadas.",
				"premium": "Muestra las lecciones premium.",
				"topics": "Filtra las lecciones por tema."
			},
			"filterNames": {
				"premium": "premium",
				"completed": "completadas",
				"topics": "tema"
			},
			"empty": {
				"searchTitle_one": "{{count}} lección oculta por la búsqueda",
				"searchTitle_other": "{{count}} lecciones ocultas por la búsqueda",
				"searchSubtitle": "Prueba con otras palabras clave o borra tu búsqueda",
				"searchCta": "Borrar búsqueda",
				"filtersTitle_one": "{{count}} lección oculta por los filtros",
				"filtersTitle_other": "{{count}} lecciones ocultas por los filtros",
				"filtersSubtitle_one": "Quita el filtro de {{filters}} para ver más",
				"filtersSubtitle_other": "Quita los filtros de {{filters}} para ver más",
				"filtersCta": "Borrar todos los filtros",
				"noneTitle": "No se encontraron lecciones",
				"noneSubtitle": "Intenta quitar los filtros o hacer una nueva búsqueda",
				"noneCta": "Restablecer todo"
			}
		},
		"home": {
			"settings": {
				"a11yLabel": "Abrir configuración"
			},
			"continueLearning": {
				"title": "Continuar aprendiendo"
			},
			"suggested": {
				"title": "Sugeridas para ti"
			},
			"completed": {
				"title": "Completadas"
			},
			"all": {
				"title": "Todas las lecciones"
			},
			"emptyState": {
				"title": "Aún no hay lecciones",
				"subtitle": "Vuelve pronto para ver nuevas lecciones."
			},
			"card": {
				"resumeCta": "Reanudar",
				"progress": "{{value}}% completado",
				"timeLeft_one": "Queda {{count}} min",
				"timeLeft_other": "Quedan {{count}} min",
				"duration_one": "{{count}} min",
				"duration_other": "{{count}} min"
			}
		},
		"overview": {
			"header": {
				"title": "Resumen"
			},
			"startCta": "Empezar a aprender",
			"objectives": {
				"title": "Objetivos de aprendizaje"
			}
		},
		"detail": {
			"takeQuizCta": "Hacer el cuestionario",
			"progress": {
				"label": "Progreso del módulo"
			},
			"activities": {
				"title": "Actividades",
				"completedCount": "{{completed}} de {{total}} completadas"
			},
			"artifact": {
				"completed": "Completado",
				"locked": "Bloqueado"
			}
		},
		"stats": {
			"insights": {
				"title": "Estadísticas de progreso"
			},
			"overallProgress": {
				"title": "Progreso general",
				"completedCount_one": "{{completed}} de {{count}} elemento completado",
				"completedCount_other": "{{completed}} de {{count}} elementos completados"
			},
			"milestones": {
				"title": "Hitos del módulo"
			}
		},
		"studyGuide": {
			"sectionBadge": {
				"label": "Sección {{number}} de {{total}}"
			},
			"upNext": {
				"title": "A continuación"
			}
		}
	},
	"sessionConfig": {
		"title": "Sesión de estudio personalizada",
		"diagnostic": "Diagnóstico",
		"skill": "Habilidades",
		"Proficiency": "Nivel de competencia",
		"Question Type": "Tipos de pregunta",
		"mastery": "Dominio",
		"sessionLength": "Duración de la sesión",
		"itemsChip_one": "{{count}} ítem",
		"itemsChip_other": "{{count}} ítems",
		"durationEstimate": "{{minutes}} min",
		"durationRange": "{{min}}–{{max}} min",
		"noItemsTooltip": "Ningún reactivo coincide con los filtros actuales",
		"setCount": "{{count}} {{type}}",
		"dismiss": "Aceptar",
		"status": {
			"notAnswered": "Sin responder",
			"needsWork": "Necesita mejorar"
		},
		"itemCount": "Completarás {{count}} reactivos de {{topics}}",
		"start": "Iniciar sesión",
		"configuringSession": "Configurando sesión",
		"fetchingContent": "Obteniendo contenido",
		"preparingMaterials": "Preparando materiales",
		"almostThere": "Ya casi está",
		"startingSession": "Iniciando sesión",
		"playIcon": "play-outline",
		"infoText": "Completarás **{{numItems}}** {{itemCount}}. Te tomará aproximadamente **{{timeString}}**.",
		"customSummary": {
			"message": "Estudia $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) de {{topics}}.",
			"messageWithMastery": "Estudia $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) de {{topics}}, con énfasis en $t(sessionConfig.customSummary.masteryLevelCount, {\"count\": {{masteryCount}}}) {{masteryLevels}}.",
			"messageAllMasteryLevels": "Estudia $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) de {{topics}} en todos los niveles de dominio.",
			"itemCount_one": "{{count}} reactivo",
			"itemCount_other": "{{count}} reactivos",
			"masteryLevelCount_one": "el nivel de dominio",
			"masteryLevelCount_other": "los niveles de dominio",
			"allTopics": "los {{count}} temas",
			"more": "{{count}} más",
			"quotedMasteryLevel": "«{{masteryLevel}}»"
		},
		"quickStudy": {
			"title": "Estudio rápido",
			"recommended": "Recomendado",
			"custom": "Personalizado",
			"selectHelper": "Toca una sesión para seleccionarla y comienza cuando estés listo.",
			"emptyRecommended": "No hay sesiones recomendadas disponibles en este momento.",
			"summary": "Estudia {{count}} reactivos de {{skill}}. Tiempo estimado: {{minutes}} minutos.",
			"summary_questionType": "Estudia {{count}} reactivos de {{skill}}, {{questionType}}. Tiempo estimado: {{minutes}} minutos.",
			"duration": "{{minutes}} min",
			"durationSelector": {
				"title": "Duración"
			},
			"levelSessions": {
				"rapidRecall": "Repaso rápido",
				"purposefulPractice": "Práctica enfocada",
				"focusFlow": "Concentración continua",
				"itemsLabel": "Reactivos de nivel {{level}}",
				"itemsLabelGeneric": "reactivos",
				"summaries": {
					"rapidRecall": "Familiarízate rápidamente con {{count}} reactivos de nivel {{level}} que aún no has respondido para ampliar tu cobertura de forma constante. Tiempo estimado: {{minutes}} minutos.",
					"purposefulPractice": "Resuelve un conjunto equilibrado de {{count}} reactivos de nivel {{level}}, comenzando con el contenido que más necesitas reforzar. Tiempo estimado: {{minutes}} minutos.",
					"focusFlow": "Refuerza tus áreas débiles con {{count}} reactivos de nivel {{level}} que has respondido con dominio bajo o medio. Tiempo estimado: {{minutes}} minutos."
				},
				"summariesGeneric": {
					"rapidRecall": "Familiarízate rápidamente con {{count}} reactivos que aún no has respondido para ampliar tu cobertura de forma constante. Tiempo estimado: {{minutes}} minutos.",
					"purposefulPractice": "Resuelve un conjunto equilibrado de {{count}} reactivos, comenzando con el contenido que más necesitas reforzar. Tiempo estimado: {{minutes}} minutos.",
					"focusFlow": "Refuerza tus áreas débiles con {{count}} reactivos que has respondido con dominio bajo o medio. Tiempo estimado: {{minutes}} minutos."
				}
			},
			"lockedOptionsBanner": "Unlock {{names}} with Premium",
			"lockedOptionsBannerOverflow": "Unlock {{names}} and {{count}} more with Premium"
		}
	},
	"skillDetail": {
		"diagnosticInsight": "Para personalizar tu experiencia, comienza con un cuestionario de diagnóstico. Los resultados de tu diagnóstico se usarán para crear tu plan de estudio."
	},
	"premium": {
		"chip": "Premium",
		"upgrade": "Mejorar a premium",
		"unlockTitle": "Desbloquea la experiencia completa de {{productName}}",
		"unlockDescription": "Desbloquea práctica personalizada diseñada en torno a tu tiempo de estudio restante.",
		"readyTitle": "Prepárate para tu examen del {{date}}",
		"tip": "Tu enfoque personalizado: premium identifica qué practicar a continuación y ajusta tu plan de estudio a medida que mejoras."
	},
	"purchase": {
		"success": {
			"headerTitle": "¡Gracias por tu compra!",
			"accessGranted": "Se te otorgó acceso a {{name}} correctamente",
			"studyPack": "Paquete de estudio",
			"practiceTest": "Examen de práctica",
			"combo": "Paquete combinado",
			"documentTitle": "Compra",
			"summary_one": "¡Felicidades! El **producto** que aparece a continuación se desbloqueó en tu cuenta. Después de presionar {{action}}, el contexto de la app cambiará para reflejar el examen: **{{examName}}**. Puedes cambiarlo en cualquier momento desde la configuración de tu cuenta si quieres estudiar para otro examen o comprar otra suscripción.",
			"summary_other": "¡Felicidades! Los **{{count}} productos** que aparecen a continuación se desbloquearon en tu cuenta. Después de presionar {{action}}, el contexto de la app cambiará para reflejar el examen: **{{examName}}**. Puedes cambiarlo en cualquier momento desde la configuración de tu cuenta si quieres estudiar para otro examen o comprar otra suscripción.",
			"unlockedDuration": "¡Felicidades! Desbloqueaste **{{duration}}** de acceso a **{{name}}**. Vencerá el **{{expiry}}**.",
			"storeNote": "Nota: los Paquetes de estudio solo se pueden usar desde nuestras apps móviles. Descarga la app correspondiente a tu dispositivo.",
			"actions": {
				"goToHome": "Ir al inicio",
				"startDiagnostic": "Comenzar {{label}}",
				"takeDiagnostic": "Hacer {{label}}",
				"takeFreeDiagnostic": "Hacer diagnóstico gratis",
				"diagnosticLabel": "diagnóstico"
			}
		},
		"checkout": {
			"headerTitle": "Completa tu compra"
		},
		"paywall": {
			"studyPackDialogTitle": "Mejora tu plan de estudio",
			"defaultDialogTitle": "Mejora tu plan de estudio",
			"practiceTestDialogTitle": "Desbloquea exámenes de práctica",
			"restorePurchaseDialogTitle": "¿Ya lo compraste?",
			"restorePurchaseDialogSubheadingWeb": "Si no, prueba esto:",
			"restorePurchaseDialogBody": "Si ya compraste este producto y sigue bloqueado, intenta lo siguiente:\n\n1. Asegúrate de haber iniciado sesión con la cuenta correcta\n2. Asegúrate de tener seleccionado el producto correcto\n3. Asegúrate de que tu suscripción no haya vencido\n4. Asegúrate de haber activado tu suscripción (revisa tu correo no deseado)\n5. Si tienes un código de acceso, [código de acceso]({{baseUrl}}/redeem)\n\nSi nada de esto aplica, **haz clic aquí**",
			"restorePurchaseDialogBodyWeb": "1. Asegúrate de haber iniciado sesión con el correo correcto\n2. Asegúrate de tener el **[examen seleccionado](/account/settings)** correcto\n3. Asegúrate de que tu suscripción no haya vencido\n\nSi nada de esto aplica, **contacta a soporte**",
			"accesDuration": {
				"yearPlan": "El plan de **{{duration}}** ofrece acceso extendido para que tengas la máxima flexibilidad de estudiar a tu ritmo y prepararte a fondo para el examen.",
				"moreTime": "Si crees que necesitarás más tiempo para estudiar, puedes considerar el plan de **{{duration}}**.",
				"otherPlan": "El plan de **{{duration}}** te dará acceso hasta el **{{expiryText}}**, por lo que tendrás suficiente tiempo para estudiar. {{moreTime}}"
			},
			"actions": {
				"upgrade": "Mejorar",
				"unlock": "Desbloquear por {{price}}",
				"subscribe": "Suscribirse por {{price}}",
				"extendAccess": "Extender acceso",
				"accessHere": "Acceder aquí",
				"redeemAccessCode": "¿Tienes un código de acceso?",
				"restorePurchase": "¿Ya lo compraste?",
				"restorePurchaseWeb": "¿Ya lo compraste o tienes un código de acceso?"
			},
			"subscriptionSummary": {
				"yearly": "Suscripción anual • Renovación automática • Cancela cuando quieras",
				"monthly": "Suscripción mensual • Renovación automática • Cancela cuando quieras",
				"weekly": "Suscripción semanal • Renovación automática • Cancela cuando quieras",
				"generic": "Suscripción con renovación automática • Cancela cuando quieras"
			},
			"planDuration": {
				"day_one": "{{count}} día",
				"day_other": "{{count}} días",
				"week_one": "{{count}} semana",
				"week_other": "{{count}} semanas",
				"month_one": "{{count}} mes",
				"month_other": "{{count}} meses",
				"year_one": "{{count}} año",
				"year_other": "{{count}} años"
			},
			"recommendedPlan": {
				"plan": "Te recomendamos el plan de **{{duration}}** para prepararte mejor para tu examen del **{{date}}**",
				"subscription": {
					"yearly": "Te recomendamos la **suscripción anual** para tener acceso continuo y prepararte para tu examen del **{{date}}**",
					"monthly": "Te recomendamos la **suscripción mensual** para tener acceso continuo y prepararte para tu examen del **{{date}}**",
					"weekly": "Te recomendamos la **suscripción semanal** para tener acceso continuo y prepararte para tu examen del **{{date}}**",
					"generic": "Te recomendamos una **suscripción** para tener acceso continuo y prepararte para tu examen del **{{date}}**"
				}
			},
			"disclaimer": "Al confirmar la compra, obtendrás acceso completo al contenido de este producto durante el periodo seleccionado. Cuando ese periodo termine, perderás el acceso al contenido restringido. Si deseas extender tu acceso por cualquier motivo (por ejemplo, si cambiaste la fecha de tu examen), puedes agregar tiempo con compras adicionales dentro de la aplicación. Para más información, consulta nuestros [Términos de Servicio y Política de Privacidad](https://memorang.com/legal)."
		}
	},
	"progress": {
		"tagProgress": {
			"subtitle": "Con base en {{numItems}} {{item}} respondidos en {{count}} {{type}}",
			"itemCount": "{{count}} {{item}}",
			"tooltip": "Esto muestra tu progreso en {{count}} {{type}}. Se basa en {{itemCount}} {{item}} que has respondido hasta ahora."
		},
		"needsImprovement": {
			"title": "Necesita mejorar",
			"subtitle": "{{type}} recomendados para que mejores",
			"cta": "Estudiar ahora"
		},
		"mastery": {
			"high": "Dominado",
			"medium": "Casi lo logras",
			"low": "Necesita práctica",
			"count": "{{count}} {{item}} respondidos",
			"zeroTooltip": "Aún no hay reactivos de {{label}} entre los {{total}} reactivos respondidos",
			"highTooltip": "Has dominado {{count}} de los {{total}} {{item}} respondidos",
			"mediumTooltip": "Estás progresando en {{count}} de los {{total}} {{item}} respondidos",
			"lowTooltip": "Necesitas practicar más con {{count}} de los {{total}} {{item}} respondidos"
		},
		"stats": {
			"completion": "Avance",
			"completionCount": "{{completed}}/{{total}} {{item}}",
			"completionTooltip": "Has completado {{completed}} de {{total}} {{item}}"
		},
		"exams": {
			"title": "Exámenes de práctica",
			"subtitle_one": "Con base en {{count}} evaluación completada",
			"subtitle_other": "Con base en {{count}} evaluaciones completadas"
		},
		"summary": {
			"title": "Resumen de aprendizaje",
			"subtitle": "Con base en {{count}} {{item}} respondidos",
			"tooltip": "Este resumen muestra tus niveles de dominio y avance en un total de {{count}} {{item}}. Tu desempeño se mide mediante sesiones de práctica, evaluaciones y actividades de estudio.",
			"mastery": "Dominio",
			"quickStats": "Estadísticas rápidas"
		},
		"languageLearning": {
			"proficiencyCardTitle": "Dominio de {{skill}}",
			"proficiencyCardTooltip": "Actualmente tienes un nivel {{level, lowercase}} de {{skill, lowercase}}",
			"itemTypesCardSubtitle_one": "{{count}} tipo de reactivo",
			"itemTypesCardSubtitle_other": "{{count}} tipos de reactivos",
			"itemTypesCardTitle": "Reactivos de {{skill}}",
			"itemTypeLevelTooltip": "Actualmente tienes un nivel {{level, lowercase}} de {{skill, lowercase}} en los tipos de pregunta “{{itemType}}”",
			"itemTypesFallbackTitle": "Tipos de reactivos",
			"itemTypesEmptyTitle": "Tipos de reactivos no disponibles",
			"itemTypesEmptySubtitle": "No pudimos encontrar tipos de reactivos para esta habilidad. Regresa a Progreso e inténtalo de nuevo.",
			"itemTypesEmptyCta": "Volver a Progreso",
			"notAnswered": "Sin responder",
			"answeredSubtitle_one": "Con base en {{count}} reactivo respondido",
			"answeredSubtitle_other": "Con base en {{count}} reactivos respondidos",
			"responsesSubtitle_one": "Basado en {{count}} respuesta",
			"responsesSubtitle_other": "Basado en {{count}} respuestas",
			"testsTakenSubtitle_one": "Con base en {{count}} examen realizado",
			"testsTakenSubtitle_other": "Con base en {{count}} exámenes realizados",
			"startFirstTest": {
				"title": "Comencemos",
				"itemsSubtitle_one": "{{count}} reactivo",
				"itemsSubtitle_other": "{{count}} reactivos",
				"guidance": {
					"diagnostic": "Empieza con un diagnóstico para descubrir tus fortalezas y ajustar tu plan de estudio.",
					"sectional": "Un examen por secciones se enfoca en una parte del examen, así obtienes un puntaje en una sesión más corta.",
					"fullMock": "Un simulacro completo reproduce el examen real de principio a fin y te da el puntaje más completo."
				}
			},
			"noScoresTitle": "Aún no tienes puntajes de {{skill, lowercase}}",
			"noScoresSubtitle": "Haz tu primer examen para ver tu puntaje estimado y el desglose de tareas.",
			"noScoresCta": "Comenzar",
			"noScoresCardSubtitle": "Con base en los exámenes que realices",
			"personalBestLabel": "Tu mejor marca personal",
			"latestLabel": "Tu más reciente",
			"examCountdown_one": "Falta {{count}} día para tu examen",
			"examCountdown_other": "Faltan {{count}} días para tu examen",
			"greeting": {
				"none": "¡Comencemos, {{firstName}}! 🚀",
				"low": "Buen comienzo, {{firstName}}. ¡Sigue así! 💪",
				"medium": "¡Sigue así, {{firstName}}! 💪",
				"high": "¡Ya casi lo logras, {{firstName}}! 🎯"
			},
			"greetingNoName": {
				"none": "¡Comencemos! 🚀",
				"low": "Buen comienzo. ¡Sigue así! 💪",
				"medium": "¡Sigue así! 💪",
				"high": "¡Ya casi lo logras! 🎯"
			},
			"stats": {
				"untilExam": "Fecha del examen",
				"itemsAnswered": "Reactivos respondidos",
				"responsesAnswered": "Respuestas"
			}
		}
	},
	"auth": {
		"incorrectPasscode": "Código de acceso incorrecto",
		"incorrectPassword": "Contraseña incorrecta. Inténtalo de nuevo.",
		"passwordPlaceholder": "Ingresa tu contraseña",
		"emailPlaceholder": "p. ej., dave@gmail.com",
		"verify": {
			"openEmail": "Abre tu correo electrónico para continuar",
			"signInCta": "Verificando tu cuenta...",
			"signUpCta": "Creando tu cuenta...",
			"contactSupport": "¿No ves el correo? Revisa tu carpeta de spam o",
			"contactSupportLink": "Contáctanos",
			"resendMagicLink": "Reenviar enlace mágico",
			"resendMagicLinkIn": "Reenviar enlace mágico en {{time}}",
			"signInBody": "¡Ya casi terminas! Estamos verificando tus datos para iniciar sesión de forma segura en la app {{appName}}.",
			"signUpBody": "¡Ya casi terminamos! Estamos verificando tus datos para crear tu nueva cuenta en la app {{appName}}.",
			"magicLinkEmail": "Enviamos un enlace mágico a **{{email}}**\nHaz clic en el enlace del correo para iniciar sesión de forma segura.",
			"magicLinkEmailExpiry": "Este enlace vence en 10 minutos",
			"confirmEmail": "Confirma tu correo electrónico",
			"redirectingToApp": "Redirigiendo a la app {{appName}}...",
			"appNotOpen": "¿La app no se abrió? Haz clic en el botón de abajo para abrir la aplicación asociada",
			"openApp": "Abrir la app {{appName}}",
			"installAppPrompt": "Si no sucede nada, asegúrate de tener instalada la app {{appName}} en tu dispositivo",
			"verifyAccountTitle": "Verifica tu cuenta",
			"emailResent": "Se envió un enlace mágico a {{email}}\nRevisa tu bandeja de entrada, incluida la carpeta de spam.",
			"verificationLinkExpired": "El enlace de verificación venció",
			"verificationLinkExpiredBody": "Los enlaces de verificación vencen después de 10 minutos y solo se pueden usar una vez. \nPuedes solicitar uno nuevo al volver a iniciar sesión",
			"accountSetupTimeoutTitle": "No pudimos completar el inicio de sesión",
			"accountSetupTimeoutBody": "La configuración de tu cuenta está tardando más de lo esperado. Intenta iniciar sesión de nuevo o contacta a soporte si el problema continúa.",
			"loginAgain": "Iniciar sesión de nuevo",
			"contactSupportExpiredLink": "Si el problema continúa, avísanos",
			"successTitle": "Ya iniciaste sesión en otra pestaña",
			"successBody": "Cierra esta pestaña o continúa desde aquí",
			"successCtaLabel": "Continuar aquí",
			"needHelpLabel": "¿Necesitas ayuda?",
			"contactSupportButton": "Contáctanos"
		},
		"contactSupportDialog": {
			"title": "¿Tienes problemas para iniciar sesión?",
			"body": "Si tienes problemas para iniciar sesión, comunícate con nuestro equipo de soporte al cliente o inténtalo de nuevo",
			"cta": "Envíanos un correo"
		},
		"emailInstruction": {
			"default": "Si no recibes un correo, revisa las carpetas de correo no deseado, spam y eliminados recientemente",
			"edu": "Si no recibes un correo, revisa las carpetas de correo no deseado, spam y eliminados recientemente, o comunícate con tu administrador de TI"
		},
		"createSessionLoader": {
			"configuringSession": "Configurando la sesión",
			"analyzingMastery": "Analizando tu dominio",
			"loadingContent": "Cargando contenido"
		}
	},
	"onboarding": {
		"steps": {
			"profile": {
				"title": "¿Cómo quieres que te llamemos?",
				"description": "Tu nombre de usuario aparece en las tablas de clasificación públicas, mientras que tu nombre se mantiene privado.",
				"usernameLabel": "Nombre de usuario",
				"firstNameLabel": "Nombre",
				"lastNameLabel": "Apellido",
				"avatarLabel": "Avatar",
				"avatarTooltip": "Los avatares se generan automáticamente con base en tu nombre de usuario.",
				"profileSaveFailed": "No pudimos guardar tu perfil. Inténtalo de nuevo."
			},
			"testDate": {
				"cta": "Continuar"
			},
			"examDate": {
				"daysAway": "Tenemos {{value}} días. Priorizaremos de inmediato las áreas que más necesitas reforzar."
			},
			"skills": {
				"chooseAll": "Elige todas las opciones que correspondan"
			},
			"plan": {
				"recommended": "Recomendado"
			},
			"toeicLevelOverview": {
				"title": "Todos empiezan por algún lugar.",
				"description": "La práctica te ayuda a dominar un nivel antes de pasar naturalmente al siguiente.",
				"illustrationLabel": "Progresión de Básico (A1–A2) a Intermedio (B1–B2) y Competente (C1).",
				"levels": {
					"basic": {
						"name": "Básico",
						"band": "A1–A2"
					},
					"intermediate": {
						"name": "Intermedio",
						"band": "B1–B2"
					},
					"proficient": {
						"name": "Competente",
						"band": "C1"
					}
				},
				"progression": {
					"title": "Cómo progresarás",
					"practiceSessions": "Practica las sesiones recomendadas",
					"buildMastery": "Desarrolla dominio en tu nivel actual",
					"growToward": "Sigue avanzando hacia Competente"
				},
				"levelDetails": {
					"title": "Qué significa cada nivel",
					"scoreRange": "{{band}} · puntuación {{min}}–{{max}}",
					"basic": {
						"name": "Usuario básico",
						"summary": "Inglés sencillo para el trabajo",
						"examples": {
							"forms": "Formularios y avisos",
							"instructions": "Instrucciones",
							"announcements": "Anuncios breves"
						}
					},
					"intermediate": {
						"name": "Usuario intermedio",
						"summary": "Comunicación cotidiana en el trabajo",
						"examples": {
							"emails": "Correos y conversaciones",
							"customers": "Interacciones con clientes",
							"followUps": "Seguimientos de reuniones"
						}
					},
					"proficient": {
						"name": "Usuario competente",
						"summary": "Inglés profesional y avanzado",
						"examples": {
							"reports": "Informes y presentaciones complejos",
							"negotiations": "Negociaciones matizadas",
							"highStakes": "Contextos profesionales de alto riesgo"
						}
					}
				},
				"disclaimer": "Las puntuaciones de TOEIC Link son referencias alineadas con el MCER, no puntos de corte absolutos. Reading y Listening progresan de forma independiente: puedes alcanzar niveles distintos en cada habilidad."
			},
			"review": {
				"diagnosticChoice": {
					"title": "Diagnóstico: {{title}}",
					"body": "{{count}} reactivos para descubrir en qué enfocarte",
					"duration": "{{minutes}} min"
				},
				"homeChoice": {
					"title": "Explorar por mi cuenta",
					"body": "Aún no quiero empezar, primero exploraré la app"
				}
			}
		},
		"common": {
			"changeLater": "Puedes cambiarlo después"
		},
		"actions": {
			"previous": "Anterior",
			"finish": "Finalizar",
			"start": "Comenzar",
			"continue": "Continuar",
			"stepIndicator": "Paso {{step}} de {{total}}"
		}
	},
	"more": {
		"profile": {
			"title": "Sobre ti"
		},
		"exam": {
			"title": "Tu examen"
		},
		"subscriptions": {
			"title": "Productos",
			"redeem": {
				"title": "Canjear compra"
			},
			"extend": {
				"cta": "Extender"
			}
		}
	},
	"examDate": {
		"noticeDialog": {
			"title": "Establece la fecha meta de tu examen",
			"description": "Esta fecha solo sirve para guiar tu plan de estudio dentro de la app. No afecta tu registro oficial del examen.",
			"dismissCta": "Ahora no",
			"confirmCta": "Establecer fecha del examen"
		}
	},
	"account": {
		"title": "Ajustes de cuenta",
		"currentExam": "Examen actual",
		"subscriptions": "Derechos de acceso",
		"examDate": "Fecha del examen",
		"examDateUpdated": "Fecha del examen establecida para el {{date}}",
		"selectDate": "Seleccionar fecha",
		"appearance": "Apariencia",
		"features": "Funciones",
		"audioPlaybackTest": "Mostrar el diálogo de prueba de reproducción de audio",
		"theme": "Tema",
		"selectTheme": "Elegir tema",
		"themeOptions": {
			"system": "Sistema",
			"light": "Claro",
			"dark": "Oscuro"
		},
		"accountInfo": "Cuenta",
		"username": "Nombre de usuario",
		"name": "Nombre",
		"nameNotSet": "Sin configurar",
		"save": "Guardar",
		"editUsername": {
			"title": "Editar nombre de usuario"
		},
		"editName": {
			"title": "Editar nombre"
		},
		"email": "Correo electrónico",
		"dev": "Desarrollo",
		"sandbox": "Entorno de pruebas",
		"redoOnboarding": "Repetir la introducción",
		"about": "Acerca de",
		"termsOfService": "Términos del servicio",
		"privacyPolicy": "Aviso de privacidad",
		"aiToolsTos": "Términos de uso de las herramientas de IA",
		"support": "Soporte",
		"supportEmailBody": "Me comunico con ustedes porque necesito ayuda con [  ]\n\n\n\nA continuación incluyo información útil para resolver el problema más rápido: \n\nNombre de usuario asociado con la cuenta (se encuentra en la configuración después de iniciar sesión en la app):\n{{username}}\n\nCorreo electrónico asociado con mi pedido (se encuentra en la configuración después de iniciar sesión en la app):\n{{email}}\n\nNúmero de pedido (por lo general se encuentra en el correo del recibo enviado al realizar la compra):\n\n¿Es posible que se haya usado un nombre o correo electrónico diferente al comprar el producto? Si es así, indíquelos:\n\nNombre y apellido:\n\nCorreo electrónico:",
		"contactSupport": "Contactar a soporte",
		"signOut": "Cerrar sesión",
		"signOutConfirmation": "¿Seguro que quieres cerrar sesión?",
		"deleteAccount": "Eliminar cuenta",
		"platform": "Plataforma",
		"partnerships": "Alianzas",
		"validUntil": "Vence el {{date}}",
		"extendValidity": "Ampliar acceso",
		"redeemPurchase": "Canjear compra",
		"redeemPurchaseNoneFound": "No hay compras disponibles para canjear",
		"redeemPurchaseCheckFailed": "No se pudieron verificar las compras. Inténtalo de nuevo.",
		"purchases": "Compras",
		"frequentlyAskedQuestions": "Preguntas frecuentes",
		"deleteFeedbackForm": {
			"placeholder": "Comentarios"
		}
	},
	"common": {
		"proficiencyLevelUnknown": "Faltan datos",
		"proficiencyLevelPendingTooltip": "Responde más reactivos de {{label}} para estimar tu nivel",
		"on": "activado",
		"gotIt": "Entendido",
		"goBack": "Volver",
		"topic": "tema",
		"itemCount_one": "{{count}} reactivo",
		"itemCount_other": "{{count}} reactivos",
		"examCount_one": "{{count}} examen",
		"examCount_other": "{{count}} exámenes",
		"questionCount_one": "{{count}} pregunta",
		"questionCount_other": "{{count}} preguntas",
		"item_one": "reactivo",
		"item_other": "reactivos",
		"and": "y",
		"this": "este",
		"of": "de",
		"knowMore": "Más información",
		"proficiency": "dominio",
		"didNotAnswer": "Reactivos que aún no has respondido",
		"notAnswered": "Sin responder",
		"attempted": "respondidos",
		"attempt": "intento",
		"activity": "actividad",
		"performance": "Desempeño",
		"estimatedProficiency": "Dominio estimado",
		"details": "detalles",
		"keepPracticing": "¡sigue practicando!",
		"leaveFeedback": "Enviar comentarios",
		"copiedToClipboard": "Copiado al portapapeles",
		"eg": "p. ej.",
		"set": "establecer",
		"hint": "pista",
		"itemType": "tipo de reactivo",
		"minute": "minuto",
		"minutes": "{{count}} minutos",
		"hour": "hora",
		"hours": "{{count}} horas",
		"continue": "Continuar",
		"unlock": "Desbloquear",
		"cancel": "Cancelar",
		"view": "Ver",
		"switch": "Cambiar",
		"update": "Actualizar",
		"ok": "Aceptar",
		"yes": "Sí",
		"free": "Gratis",
		"answered": "Respondido",
		"correct": "Correcto",
		"incorrect": "Incorrecto",
		"marked": "Marcado",
		"unmarked": "Sin marcar",
		"skipped": "Omitido",
		"skill_one": "habilidad",
		"skill_other": "habilidades",
		"word_one": "palabra",
		"word_other": "palabras",
		"submitResponse": "Enviar respuesta",
		"viewDetails": "Ver detalles",
		"sec_one": "s",
		"sec_other": "s",
		"point_one": "punto",
		"point_other": "puntos",
		"week": "Semana",
		"month": "Mes",
		"year": "Año",
		"day": "Día",
		"selectTestDate": "Seleccionar fecha del examen",
		"points": "Puntos",
		"viewAll": "Ver todo",
		"timeline": "Cronología",
		"save": "Guardar",
		"filters": {
			"selectAll": "Seleccionar todo",
			"deselectAll": "Deseleccionar todo",
			"selectedCount": "{{count}} seleccionadas",
			"expandSection": "Expandir {{section}}",
			"collapseSection": "Contraer {{section}}"
		},
		"showMore": "Mostrar más",
		"showLess": "Mostrar menos",
		"expandA11yLabel": "Expandir descripción",
		"collapseA11yLabel": "Contraer descripción",
		"done": "Listo",
		"clearAll": "Borrar todo",
		"clear": "Borrar",
		"datePicker": {
			"title": "Seleccionar fecha",
			"enterDateLabel": "Ingresar fecha",
			"enterDateRangeLabel": "Ingresar fechas",
			"dateLabel": "Fecha",
			"startDateLabel": "Fecha de inicio",
			"endDateLabel": "Fecha de fin",
			"dateRequiredError": "La fecha es obligatoria",
			"invalidDateFormatError": "Formato de fecha inválido. Usa MM/DD/YYYY",
			"startAfterEndError": "La fecha de inicio no puede ser posterior a la fecha de fin",
			"endBeforeStartError": "La fecha de fin no puede ser anterior a la fecha de inicio",
			"minDateError": "La fecha debe ser {{date}} o posterior",
			"maxDateError": "La fecha debe ser {{date}} o anterior",
			"dateRangeError": "La fecha debe estar entre {{startDate}} y {{endDate}}",
			"setDateCta": "Establecer fecha",
			"nextCta": "Siguiente",
			"setTimeCta": "Establecer hora"
		}
	},
	"session": {
		"choicePercentageTooltip": "El {{percentage}} de los estudiantes eligió esta respuesta.",
		"choiceCorrectA11yLabel": "Respuesta correcta",
		"choiceIncorrectA11yLabel": "Respuesta incorrecta",
		"choiceNotSelectedA11yLabel": "No seleccionada",
		"moreItemsAlertDialog": {
			"title": "Reactivos adicionales",
			"cta": "Entendido"
		},
		"results": {
			"followUps": {
				"title": "Seguimiento"
			},
			"summary": {
				"sessionAnalysis": "Análisis de la sesión",
				"itemCount_one": "{{count}} reactivo",
				"itemCount_other": "{{count}} reactivos",
				"skilledItemCount_one": "{{count}} reactivo de {{skills}}",
				"skilledItemCount_other": "{{count}} reactivos de {{skills}}",
				"levelPhrase_one": "del nivel {{levels}}",
				"levelPhrase_other": "de los niveles {{levels}}",
				"message": "<bold>¡Excelente trabajo!</bold> Acabas de completar {{itemPhrase}} en {{timeTaken}}.",
				"messageWithLevels": "<bold>¡Excelente trabajo!</bold> Acabas de completar {{itemPhrase}} $t(session.results.summary.levelPhrase, {\"count\": {{levelCount}}, \"levels\": \"{{levels}}\"}) en {{timeTaken}}.",
				"proficiencyEstimateReady": "Tu nivel estimado de {{skill}} es <bold>{{currentLevel}}</bold>. Ya puedes avanzar a <bold>{{nextLevel}}</bold>.",
				"proficiencyEstimateKeepPracticing": "Tu nivel estimado de {{skill}} es <bold>{{currentLevel}}</bold>. Sigue practicando antes de avanzar a <bold>{{nextLevel}}</bold>.",
				"proficiencyEstimateHighest": "Tu nivel estimado de {{skill}} es <bold>{{currentLevel}}</bold>. ¡Trabajo sobresaliente!",
				"mixedLevel": "Mixto",
				"overallScore": "Puntuación general",
				"stats": {
					"itemsAttempted_one": "Reactivo contestado",
					"itemsAttempted_other": "Reactivos contestados",
					"pointsEarned_one": "Punto obtenido",
					"pointsEarned_other": "Puntos obtenidos",
					"answeredCorrectly": "Contestado correctamente",
					"timeTaken": "Tiempo empleado",
					"target": "Objetivo",
					"ofTotal": "de {{total}}",
					"ofPointsTotal": "de {{total}}",
					"skill": "Habilidad",
					"skills": "Habilidades",
					"questionType": "Tipo de pregunta",
					"questionTypes": "Tipos de pregunta",
					"proficiencyLevel": "Nivel de dominio",
					"proficiencyLevels": "Niveles de dominio"
				}
			}
		},
		"prepBanner": {
			"audioStartsIn": "El audio comienza en {{seconds}} s",
			"audioStartsInPlayOnce": "El audio comienza en {{seconds}} s y solo se reproduce una vez",
			"videoStartsIn": "El video comienza en {{seconds}} s",
			"videoStartsInPlayOnce": "El video comienza en {{seconds}} s y solo se reproduce una vez",
			"recordingIn": "La grabación comienza en {{seconds}} s"
		},
		"timeOverrunBanner": {
			"message": "Se acabó el tiempo. En el examen real, lo que respondieras después de este momento no se calificaría. Puedes seguir practicando."
		},
		"attributes": {
			"stimulus": "estímulo"
		},
		"stimulusTypes": {
			"reading": "Lectura",
			"listening": "Comprensión auditiva",
			"speaking": "Expresión oral",
			"writing": "Expresión escrita",
			"image": "Imagen"
		},
		"masteryLevels": {
			"belowBasic": "Inferior a básico",
			"basic": "Básico",
			"belowLowIntermediate": "Inferior a intermedio bajo",
			"lowIntermediate": "Intermedio bajo",
			"highIntermediate": "Intermedio alto",
			"advanced": "Avanzado",
			"proficiencySubtitle": "En {{trademark}}, esto equivale a una puntuación de **{{minScore}}-{{maxScore}}/30**",
			"infoSectionLabel": "Información de la sección {{skill}}",
			"infoSectionText": {
				"Reading": "La sección de Lectura de {{trademark}} evalúa qué tan bien puedes leer y comprender materiales escritos usados en un entorno académico. Incluye dos textos de aproximadamente 700 palabras cada uno, con 10 preguntas por texto. Completar la sección de Lectura debe tomar alrededor de 35 minutos.",
				"Listening": "La sección de Comprensión auditiva de {{trademark}} está diseñada para medir tu capacidad de comprender conversaciones y clases en inglés. Evalúa la comprensión básica, la actitud y el grado de certeza del hablante, y la relación entre datos. Completar la sección de Comprensión auditiva debe tomar alrededor de 36 minutos.",
				"Speaking": "La sección de Expresión oral de {{trademark}} mide tu capacidad de hablar inglés eficazmente en entornos académicos. Las cuatro preguntas o tareas se parecen a situaciones reales que podrías encontrar dentro y fuera del salón de clases. Completar la sección de Expresión oral debe tomar alrededor de 16 minutos.",
				"Writing": "La sección de Expresión escrita del examen {{trademark}} mide tu capacidad de escribir en inglés en un entorno académico y presentar tus ideas de forma clara y organizada. Escribirás tus respuestas con el teclado de una computadora y completar esta sección debe tomar alrededor de 29 minutos."
			}
		},
		"itemTypes": {
			"MCSS": "Opción múltiple de selección única",
			"MCSSH": "Opción múltiple de selección única con resaltado",
			"MCMS": "Opción múltiple de selección múltiple",
			"MCMSH": "Opción múltiple de selección múltiple con resaltado",
			"INSERT_TEXT": "Insertar texto",
			"MATCH_MS": "Relacionar con selección múltiple",
			"MCSSM": "Relacionar con opción múltiple de selección única",
			"MCMSM": "Relacionar con opción múltiple de selección múltiple",
			"MCGS": "Seleccionar opción para completar",
			"MCOS": "Ordenar opciones",
			"LISTENING_REPLAY": "Repetición de audio",
			"AUDIO_INPUT": "Respuesta de audio",
			"ACADEMIC_DISCUSSION_RESPONSE": "Respuesta a una discusión académica",
			"INTEGRATED_WRITING_RESPONSE": "Respuesta escrita integrada"
		},
		"passageStem": {
			"itemOfTotal": "Reactivo {{current}} de {{total}}",
			"questionOfTotal": "Pregunta {{current}} de {{total}}",
			"stimulusCorrespondsToNextItems": "El siguiente estímulo corresponde a los próximos {{total}} reactivos",
			"passage": "Texto",
			"lecture": "Clase",
			"professorsQuestion": "Pregunta del profesor",
			"listen": "Escuchar",
			"openPassage": "Abrir texto",
			"backToItem": "Volver al reactivo",
			"notYetInserted": "Aún no insertado",
			"insertedAtPosition": "Insertado en la posición #{{position}}"
		},
		"hint": {
			"show": "Mostrar pista"
		},
		"navigation": {
			"next": "Siguiente",
			"exit": "Salir",
			"saveAndExit": "Guardar y salir",
			"previous": "Anterior",
			"skip": "Omitir",
			"finish": "Finalizar",
			"help": "Ayuda",
			"about": "Consejos",
			"questionsButtonLabel": "Navegación de preguntas",
			"questionsButtonTooltip": "Ve a cualquier pregunta o revisa las marcadas",
			"questionsButtonActiveFiltersA11y": "Filtros activos: {{count}}",
			"recordingInProgressTooltip": "No puedes salir de este reactivo mientras la grabación está en curso",
			"questionNotReachedTooltip": "Aún no has llegado a esta pregunta"
		},
		"questionTips": {
			"hideFutureLabel": "No mostrar consejos automáticamente"
		},
		"toolbar": {
			"calculatorTooltip": "Abrir calculadora",
			"highlightTooltip": "Selecciona texto para resaltar información importante y consultarla fácilmente",
			"markTooltip": "Marca esta pregunta para revisarla antes de enviar",
			"unmarkTooltip": "Haz clic para desmarcar esta pregunta"
		},
		"summary": {
			"viewFullInsights": "Ver análisis completo",
			"targetTooltip": "El objetivo de desempeño de esta sesión."
		},
		"stats": {
			"skill": "Habilidad",
			"answered": "Respondido",
			"speed": "Velocidad",
			"duration": "Duración",
			"duration_tooltip": "La duración de tu respuesta grabada: {{duration}} $t(common.sec, {\"count\": {{duration}}})",
			"confidence": "Confianza",
			"pointsEarned": "Puntos",
			"word": "Palabra",
			"words": "Palabras",
			"time_taken": "{{time}} {{sec}}",
			"time_taken_tooltip": "Tardaste {{time_taken}} $t(common.sec, {\"count\": {{time_taken}}}) en leer y responder este reactivo",
			"skill_tooltip": "El área de habilidad evaluada en este reactivo: {{skill}}",
			"answered_correct_tooltip": "La respuesta que enviaste fue correcta",
			"answered_incorrect_tooltip": "La respuesta que enviaste fue incorrecta",
			"skipped_tooltip": "No enviaste una respuesta para este reactivo",
			"words_tooltip": "Número de palabras en tu respuesta escrita: {{count}}",
			"word_tooltip": "Número de palabras en tu respuesta escrita: {{count}}",
			"confidence_tooltip": "Qué tanta confianza tenías al enviar tu respuesta",
			"points_earned_tooltip_one": "Obtuviste {{points}} punto de un máximo de {{maximumScore}} para este reactivo",
			"points_earned_tooltip_other": "Obtuviste {{points}} puntos de un máximo de {{maximumScore}} para este reactivo",
			"challengers_tooltip": "Número de estudiantes que contestaron este reactivo antes que tú: {{count}}",
			"learning_mode_points_tooltip": "Puntos obtenidos en este intento: +{{xp}} XP",
			"pts_earned_tooltip": "Puntos obtenidos en este intento: {{xp}} XP"
		},
		"breakdownItemTypes": {
			"expandCta": "Ampliar desglose"
		},
		"explanation": {
			"title": "Explicación",
			"feedback": "Comentarios",
			"skippedFeedbackNotice": "Omitiste esta pregunta, por lo que no se generaron comentarios personalizados."
		},
		"followUps": "Seguimiento",
		"suggestCorrection": "Sugerir una corrección",
		"answer": {
			"correct": "Correcta",
			"incorrect": "Incorrecta",
			"skipped": "Omitida"
		},
		"confidence": {
			"high": "Alta",
			"medium": "Media",
			"low": "Baja"
		},
		"endDialog": {
			"title": "¿Finalizar la sesión antes de tiempo?",
			"confirmEndDiagnostic": "¿Seguro que quieres finalizar la sesión? Perderás todo el progreso y tendrás que comenzar de nuevo.",
			"confirmEnd": "Aún te quedan {{num}} {{itemLabel}}. Puedes finalizar ahora o seguir estudiando para completarlos.",
			"confirmEndNoAnswer": "Aún no has respondido ninguna pregunta. ¿Seguro que quieres finalizar ahora?",
			"confirmEndNoAnswerPositive": "Seguir estudiando",
			"confirmEndNoAnswerNegative": "Finalizar ahora"
		},
		"permissionDialog": {
			"title": "Se necesita acceso al micrófono",
			"descriptionWeb": "La práctica de expresión oral usa tu micrófono. Tu navegador está bloqueando el acceso para este sitio: haz clic en el ícono de permisos junto a la dirección web, permite el micrófono y vuelve a intentarlo.",
			"descriptionMobile": "La práctica de expresión oral usa tu micrófono. Permite el acceso al micrófono en la configuración de tu dispositivo para continuar.",
			"promptDescriptionWeb": "La práctica de expresión oral usa tu micrófono. Solicita el permiso y elige Permitir cuando tu navegador lo pida.",
			"blockedDescriptionWeb": "El acceso al micrófono está bloqueado para este sitio. Haz clic en el ícono junto a la dirección web, permite el micrófono y vuelve a solicitar el permiso.",
			"ok": "Aceptar",
			"cancel": "Cancelar",
			"openSettings": "Abrir configuración",
			"requestPermission": "Solicitar permiso",
			"dismissAndExit": "Descartar y salir",
			"learnMore": "Más información"
		},
		"audioPlaybackTestDialog": {
			"title": "Probar reproducción de audio",
			"description": "La app {{appName}} incluye varias funciones de reproducción de audio, como las de estímulos, reactivos y texto a voz. Para tener la mejor experiencia, prueba el audio a continuación. Cuando confirmes que funciona, continúa.",
			"troubleshooting": {
				"title": "Solución de problemas de audio",
				"volumeTitle": "Revisa el volumen del dispositivo",
				"volumeDescriptionWeb": "Ajusta el volumen con los controles del teclado o la configuración de volumen del sistema en el menú o la barra de tareas",
				"volumeDescriptionMobile": "Usa los botones de volumen del dispositivo o ajústalo en la configuración del sistema",
				"outputTitle": "Verifica el dispositivo de salida de audio",
				"outputDescription": "Si usas audífonos, asegúrate de que estén bien conectados y seleccionados como dispositivo de salida activo",
				"browserTitle": "Revisa el audio de la pestaña del navegador",
				"browserDescription": "Busca un ícono de altavoz silenciado junto al título de la pestaña y activa el sonido si aparece."
			},
			"skipCheck": "Omitir esta revisión la próxima vez",
			"workingButton": "Confirmar audio",
			"textToHear": "Debes escuchar: {{text}}"
		},
		"overall": "General",
		"subskills": {
			"content": {
				"title": "Contenido"
			},
			"languageUse": {
				"title": "Uso del idioma"
			},
			"organizationAndDevelopment": {
				"title": "Organización y desarrollo"
			},
			"topicDevelopment": {
				"title": "Desarrollo del tema"
			},
			"delivery": {
				"title": "Expresión"
			}
		},
		"finalizing": {
			"title": "Finalizando tus resultados",
			"gradingProgress": "Calificando respuestas..."
		}
	},
	"questionTypes": {
		"descriptions": {
			"Repeat Sentence": "Una tarea de expresión oral en la que el estudiante repite una oración que escuchó con la mayor precisión posible.",
			"Read Aloud": "Un reactivo de expresión oral en el que el estudiante lee un pasaje en voz alta para su evaluación.",
			"Describe Image": "Una tarea de expresión oral en la que el estudiante describe en detalle un estímulo visual.",
			"Write Essay": "Una tarea de respuesta construida que requiere un ensayo estructurado sobre un tema dado.",
			"Retell Lecture": "Una tarea de expresión oral en la que el estudiante resume una conferencia o charla que escuchó.",
			"Summarize Group Discussion": "Una tarea de comprensión auditiva en la que el estudiante resume una discusión entre varios hablantes.",
			"Answer Short Question": "Una breve tarea de expresión oral en la que se responde una sola pregunta corta con una respuesta concisa.",
			"Respond to a Situation": "Una tarea de expresión oral en la que el estudiante responde adecuadamente a una situación descrita.",
			"Summarize Written Text": "Una tarea de comprensión lectora en la que el estudiante resume un pasaje con sus propias palabras.",
			"Reorder Paragraph": "Una tarea de comprensión lectora en la que el estudiante ordena párrafos desordenados en la secuencia correcta.",
			"Fill in the Blanks (Dropdown)": "Una tarea de comprensión lectora en la que cada espacio se completa con una lista desplegable de opciones.",
			"Fill in the Blanks (Type In)": "Una tarea de comprensión auditiva en la que el estudiante escribe la palabra o frase corta que falta.",
			"Fill in the Blanks (Drag and Drop)": "Una tarea de comprensión lectora en la que las palabras faltantes se completan arrastrando opciones a los espacios.",
			"Multiple Choice, Single Answer": "Un reactivo de opción múltiple en el que el estudiante selecciona una respuesta correcta.",
			"Multiple Choice, Single Answer (Reading)": "Un reactivo de opción múltiple de comprensión lectora en el que el estudiante selecciona una respuesta correcta.",
			"Multiple Choice, Single Answer (Listening)": "Un reactivo de opción múltiple de comprensión auditiva en el que el estudiante selecciona una respuesta correcta.",
			"Multiple Choice, Multiple Answers": "Un reactivo en el que el estudiante puede seleccionar más de una respuesta correcta.",
			"Multiple Choice, Multiple Answers (Reading)": "Un reactivo de comprensión lectora en el que el estudiante puede seleccionar más de una respuesta correcta.",
			"Multiple Choice, Multiple Answers (Listening)": "Un reactivo de comprensión auditiva en el que el estudiante puede seleccionar más de una respuesta correcta.",
			"Summarize Spoken Text": "Una tarea de comprensión auditiva en la que el estudiante escribe un resumen de lo que escuchó.",
			"Highlight Correct Summary": "Una tarea de comprensión auditiva en la que el estudiante resalta el resumen que mejor coincide con el audio.",
			"Select Missing Word": "Una tarea de comprensión auditiva tipo cloze en la que el estudiante elige la palabra que falta.",
			"Highlight Incorrect Words": "Una tarea de comprensión auditiva en la que el estudiante resalta las palabras de la transcripción que difieren del audio.",
			"Write from Dictation": "Una tarea de comprensión auditiva en la que el estudiante transcribe una oración que escucha."
		}
	},
	"report": {
		"readFullInsights": "Leer análisis completo",
		"productName": "{{examName}} {{type}}",
		"startedAt": "Comenzó a las {{time}}",
		"itemTypesTitle": "Desglose por tipo de reactivo",
		"itemTypesFilterAll": "Todos",
		"questionTypeCardTitle": "Desglose por tipo de reactivo de {{skill}}",
		"questionTypeCardSubtitle_one": "Con base en {{count}} tipo de reactivo de {{skill}} en esta sesión",
		"questionTypeCardSubtitle_other": "Con base en {{count}} tipos de reactivo de {{skill}} en esta sesión",
		"questionTypeCardAltSubtitle_one": "{{count}} tipo",
		"questionTypeCardAltSubtitle_other": "{{count}} tipos",
		"questionTypeRowSubtitle_zero": "Ningún reactivo respondido",
		"questionTypeRowSubtitle_one": "{{count}} reactivo respondido",
		"questionTypeRowSubtitle_other": "{{count}} reactivos respondidos",
		"itemTypeDetail": {
			"review_one": "Revisar reactivo",
			"review_other": "Revisar reactivos",
			"stats": {
				"answered_one": "Reactivo respondido",
				"answered_other": "Reactivos respondidos",
				"avgTime": "Tiempo prom. por reactivo"
			}
		},
		"reviewAnswersDialog": {
			"title": "Revisar respuestas",
			"sections": {
				"skills": "Habilidades",
				"questionTypes": "Tipos de pregunta",
				"proficiency": "Dominio",
				"performance": "Desempeño"
			},
			"summaryNone": "Selecciona filtros con reactivos para continuar.",
			"summaryAll_one": "Revisa {{count}} respuesta.",
			"summaryAll_other": "Revisa las {{count}} respuestas.",
			"summaryFiltered_one": "Revisa {{count}} respuesta que coincide con {{filters}}.",
			"summaryFiltered_other": "Revisa {{count}} respuestas que coinciden con {{filters}}.",
			"reviewAnswers_one": "Revisar {{count}} respuesta",
			"reviewAnswers_other": "Revisar {{count}} respuestas",
			"more": "{{count}} más"
		},
		"itemDetail": {
			"title": "Revisar mis respuestas",
			"filterAll": "Todos",
			"filterCorrect": "Correctos",
			"filterIncorrect": "Incorrectos",
			"filterMarked": "Marcados",
			"emptyTitle": "No hay reactivos que coincidan",
			"emptyDescription": "Ningún reactivo de tu sesión coincide con el filtro seleccionado ({{filter}}). Ajusta o borra los filtros para ver más resultados.",
			"emptyCta": "Borrar filtros"
		},
		"answerCardTitle": "Revisión de reactivos",
		"answerCardSubtitle_one": "Con base en {{count}} reactivo",
		"answerCardSubtitle_other": "Con base en {{count}} reactivos",
		"skillsBreakdown": {
			"title": "Desglose por habilidad",
			"subtitle_one": "Con base en {{count}} reactivo",
			"subtitle_other": "Con base en {{count}} reactivos"
		},
		"studyPack": "Study-Pack",
		"practiceTestCompleted": "Examen de práctica completado",
		"studySessionCompleted": "Sesión de estudio completada",
		"diagnosticSessionCompleted": "Sesión de diagnóstico completada",
		"timeElapsed": "Tiempo transcurrido",
		"stats": {
			"answered": "RESPONDIDOS",
			"time elapsed": "TIEMPO TRANSCURRIDO",
			"avg speed": "VELOCIDAD PROM.",
			"hints used": "PISTAS USADAS"
		},
		"pointsInfo": {
			"feedbackText": {
				"advanced": "¡Excelente trabajo! Sigue esforzándote para alcanzar la excelencia.",
				"highIntermediate": "¡Vas muy bien! Sigue reforzando tus fortalezas.",
				"lowIntermediate": "Tu avance es constante. ¡Sigue así!",
				"basic": "¡Sigue trabajando para mejorar tus habilidades!"
			},
			"infoText": "Completaste **{{numActivities}} {{activityLabel}}** para practicar {{skillsText}} {{skills}}. {{skillDetails}}. En total, obtuviste **{{numPointsEarned}} de {{numTotalPoints}} puntos**, lo que indica un dominio **{{compositeLevel}}** en {{thisText}} {{skills}}. {{compositeFeedback}}",
			"infoText.singleSkill": "Completaste **{{itemCount}} {{itemLabel}}** enfocados en tu habilidad de **{{skill_1}}**. Obtuviste **{{skill_1_score}} de {{skill_1_total}}**, lo que indica un dominio **{{proficiency}}**. {{compositeFeedback}}",
			"infoText.multiSkill": "Completaste **{{itemCount}} {{itemLabel}}** y practicaste tus habilidades de **{{skills_text}}**. {{skill_details}} En total, obtuviste **{{overall_score}} de {{overall_total}} puntos**, lo que indica un dominio **{{overall_proficiency}}** en estas habilidades. {{compositeFeedback}}",
			"skillDetails": "En **{{skill}}**, obtuviste **{{score}} de {{total}}**, lo que muestra un dominio **{{proficiency}}**."
		},
		"actions": {
			"goToHome": "Ir al inicio",
			"studyMore": "Estudiar más",
			"studyFree": "Estudiar {{tagTypes}} gratis",
			"reviewAnswers": "Revisar respuestas"
		},
		"nextAction": {
			"title": "Recomendado: práctica de {{focus}}",
			"dialog": {
				"title": "Sesión de estudio recomendada",
				"subtitle": "Enfócate en tus áreas de oportunidad"
			},
			"fallback": {
				"title": "Sigue practicando",
				"description": "Crea una sesión de estudio con las áreas en las que quieres trabajar a continuación."
			}
		},
		"premium": {
			"upgradeCta": "Mejorar a premium"
		},
		"disclaimer": {
			"title": "Aviso",
			"summativeBody": "Las puntuaciones de los exámenes de práctica son estimaciones y no garantizan el mismo resultado en un examen {{examName}} real. Las puntuaciones pueden variar según las condiciones del examen y la calificación oficial."
		},
		"performance": {
			"title": "Desempeño",
			"subtitle": "Con base en {{count}} reactivos",
			"correct": "Correctos",
			"correctItems": "{{count}} reactivos",
			"incorrect": "Incorrectos",
			"incorrectItems": "{{count}} reactivos"
		},
		"mastery": {
			"performanceTitle": "Desempeño",
			"sessionMasteryTitle": "Dominio estimado",
			"subtitle_assessment": "Con base en los {{count}} {{item}} de esta evaluación",
			"subtitle_session": "Con base en los {{count}} {{item}} de esta sesión"
		},
		"sessionAnalysis": {
			"title": "Análisis de la sesión",
			"subtitle": "Análisis y recomendaciones personalizadas",
			"viewFullAnalysis": "Ver análisis",
			"feedbackDialog": {
				"body": "Publicamos actualizaciones casi todos los días y queremos seguir mejorando. ¿Podrías dejarnos tus comentarios?",
				"placeholder": "Escribe tus comentarios aquí",
				"cta": "Enviar comentarios",
				"successMessage": "Comentarios enviados. ¡Gracias!",
				"feedbackLimitError": "Los comentarios deben tener al menos 10 caracteres"
			},
			"menuActions": {
				"copy": "Copiar",
				"altCopy": "Copiar texto del resumen",
				"altPositiveFeedback": "Esto fue útil",
				"positiveFeedback": "Buena respuesta",
				"negativeFeedback": "Mala respuesta",
				"reportIssue": "Reportar",
				"altReportIssue": "Reportar esta respuesta",
				"emailSummary": "Enviar resumen por email",
				"emailAlreadySent": "El email ya se envió",
				"copiedAnalysis": "Análisis copiado al portapapeles",
				"emailSent": "Email enviado a {{email}}. Si no lo recibes, revisa las carpetas de correo no deseado, spam y eliminados recientemente",
				"emailFailed": "No se pudo enviar el email a {{email}}",
				"emailInstructionMessage": "Si no recibes el email, revisa las carpetas de correo no deseado, spam y eliminados recientemente, o comunícate con tu administrador de TI"
			}
		}
	},
	"feedback": {
		"successMessage": "Comentarios enviados. ¡Gracias!"
	},
	"dialog": {
		"feedback": {
			"defaultFeedbackBody": "¿Qué te gusta? ¿Qué podría mejorar? Mejoramos la plataforma todos los días y nuestro equipo lee cada comentario. ¡Gracias!",
			"title": "Comparte tus comentarios",
			"body": "¿Qué te gusta? ¿Qué podría mejorar? Mejoramos la plataforma todos los días y nuestro equipo lee cada comentario. **¡Gracias!**",
			"positiveBody": "¡Nos alegra que haya sido útil! Cuéntanos **qué te gustó.**",
			"negativeBody": "Ayúdanos a entender qué salió mal para que podamos **mejorar nuestras respuestas.**",
			"placeholder": "Escribe tus comentarios",
			"cta": "Enviar comentarios"
		},
		"report": {
			"title": "Enviar reporte",
			"body": "Ayúdanos a entender qué está mal en esta respuesta",
			"cta": "Enviar reporte"
		},
		"suggestCorrection": {
			"title": "Sugerir una corrección",
			"body": "Ayúdanos a mejorar la precisión de este contenido al **reportar cualquier error.**",
			"cta": "Enviar"
		},
		"feedbackReasons": {
			"negative": {
				"inaccurate": {
					"title": "Inexacta",
					"description": "La respuesta contiene información incorrecta"
				},
				"notHelpful": {
					"title": "No fue útil",
					"description": "La respuesta no abordó mi pregunta"
				},
				"incomplete": {
					"title": "Incompleta",
					"description": "A la respuesta le faltan detalles importantes"
				},
				"hardToUnderstand": {
					"title": "Difícil de entender",
					"description": "La respuesta fue confusa o poco clara"
				},
				"other": {
					"title": "Otro",
					"description": "Otro motivo"
				}
			},
			"report": {
				"misinformation": {
					"title": "Información falsa",
					"description": "La respuesta contiene información falsa o engañosa"
				},
				"harmfulContent": {
					"title": "Contenido dañino u ofensivo",
					"description": "Discurso de odio, acoso o lenguaje inapropiado"
				},
				"violatesPolicies": {
					"title": "Infringe las políticas",
					"description": "Spam, autopromoción o contenido ilegal"
				},
				"other": {
					"title": "Otro",
					"description": "Describe con tus propias palabras qué salió mal"
				}
			}
		},
		"faqs": {
			"title": "Preguntas frecuentes",
			"body": "Estas son algunas de las preguntas más frecuentes sobre la app. Si tienes alguna otra pregunta, comunícate con nosotros en support@memorang.ai"
		},
		"delete": {
			"title": "Eliminar cuenta",
			"body": "Lamentamos que te vayas y te deseamos mucho éxito en tu trayectoria académica y profesional.",
			"options": "Es demasiado caro|Ya presenté mi examen|No me gustó el contenido|Faltan funciones|Otro",
			"confirmdelete": {
				"title": "Confirmar eliminación de la cuenta",
				"cta": "Eliminar",
				"errorMessage": "Ese email no coincide con esta cuenta. Inténtalo de nuevo",
				"successMessage": "¡Cuenta eliminada correctamente!",
				"validEmail": "Ingresa un email válido"
			}
		}
	},
	"recorder": {
		"tapToRecord": "Toca para grabar tu respuesta",
		"responseAudioUnavailable": "El audio de la respuesta no está disponible para reproducirse",
		"recording": "Grabando",
		"recordingCompleted": "Grabación completada",
		"getReady": "Prepárate",
		"timeIsUp": "Se acabó el tiempo. Tu respuesta no se grabó.",
		"alert": {
			"title": "Se alcanzó la duración máxima",
			"body": "La grabación se detuvo porque alcanzó la duración máxima de {{maxDuration}} segundos."
		},
		"uiElementPressed": "La grabación se detuvo porque se abrió el estímulo durante una grabación activa."
	},
	"writing": {
		"placeholder": "Escribe tu respuesta aquí...",
		"wordCount": "{{count}} {{word}}",
		"title": "Tu respuesta",
		"submit": "Enviar",
		"helper": {
			"range": "Escribe de {{min}} a {{max}} palabras para enviar tu respuesta",
			"min": "Escribe al menos {{min}} palabras para enviar tu respuesta",
			"max": "Reduce tu respuesta a {{max}} palabras o menos"
		}
	},
	"navbar": {
		"home": "Inicio",
		"progress": "Progreso",
		"insights": "Perspectivas",
		"leaderboard": "Clasificación",
		"store": "Tienda",
		"more": "Más",
		"redeem": "Canjear",
		"study-pack": "Study-Pack",
		"podcasts": "Podcasts",
		"modules": "Módulos",
		"account": "Ajustes de cuenta",
		"accountTab": "Cuenta",
		"privacy": "Privacidad",
		"terms": "Términos",
		"cme": "CME"
	},
	"redeem": {
		"contactSupportHint": "¿Ingresaste el código correctamente y aún tienes problemas? **Contacta a soporte** y asegúrate de incluir tu código de acceso y los detalles de tu compra",
		"olxDialog": {
			"unlockedTitle": "Acceso desbloqueado",
			"expiredTitle": "Acceso vencido",
			"testInfo": "**Examen:** {{examName}} | **Prueba:** {{bundleName}}",
			"upcomingBody_one": "¡Tu acceso a la prueba OLX se ha desbloqueado!\n\nPuedes iniciar tu sesión en **{{count}} día**. Vuelve a consultarlo más tarde para comenzar tu sesión desde la pestaña Pruebas de práctica.",
			"upcomingBody_other": "¡Tu acceso a la prueba OLX se ha desbloqueado!\n\nPuedes iniciar tu sesión en **{{count}} días**. Vuelve a consultarlo más tarde para comenzar tu sesión desde la pestaña Pruebas de práctica.",
			"activeBody": "¡Tu acceso a la prueba OLX ya está activo!\n\nPuedes iniciar tu sesión en cualquier momento antes del **{{date}}**.\n\n¿Quieres comenzar tu sesión ahora o más tarde?",
			"expiredBody": "Tu acceso a la prueba OLX venció el **{{date}}**.\n\nComunícate con tu profesor o con el administrador de tu escuela para obtener más ayuda.",
			"startNowCta": "Comenzar ahora",
			"startLaterCta": "Comenzar después"
		},
		"unexpectedError": "Ocurrió un error inesperado."
	},
	"redeemCode": {
		"titleRedeem": "Canjear acceso",
		"titleGranted": "Acceso otorgado",
		"formTitle": "Ingresa tu código de acceso",
		"accessCodeHint": "Si tienes un código de acceso, ingrésalo aquí, incluidos los guiones.",
		"submit": "Enviar",
		"access": "Acceder aquí",
		"helpFindCode": "¿Necesitas ayuda para encontrar tu código de acceso?",
		"troubleRedeeming": "¿Tienes problemas para canjearlo? ¡Pregunta a Assistant!",
		"skipStep": "Omitir este paso"
	},
	"autoRedeem": {
		"redeem": "Canjear",
		"redeeming": "Canjeando...",
		"continue": "Continuar",
		"unredeemedPrompt_one": "Hay **{{count}} suscripción** asociada con el email **{{email}}** que no se ha canjeado. ¿Quieres agregarla a tu cuenta?",
		"unredeemedPrompt_other": "Hay **{{count}} suscripciones** asociadas con el email **{{email}}** que no se han canjeado. ¿Quieres agregarlas a tu cuenta?",
		"successMessage_one": "¡Felicidades! El **producto** que aparece a continuación se desbloqueó en tu cuenta. Después de presionar Continuar, el contexto de la app cambiará para reflejar el examen: **{{examName}}**. Puedes cambiarlo en cualquier momento desde la configuración de tu cuenta si quieres estudiar para otro examen o comprar otra suscripción.",
		"successMessage_other": "¡Felicidades! Los **{{count}} productos** que aparecen a continuación se desbloquearon en tu cuenta. Después de presionar Continuar, el contexto de la app cambiará para reflejar el examen: **{{examName}}**. Puedes cambiarlo en cualquier momento desde la configuración de tu cuenta si quieres estudiar para otro examen o comprar otra suscripción."
	},
	"olxEligibility": {
		"goToPracticeTests": "Ir a exámenes de práctica"
	},
	"moreChallenges": {
		"challenges": "Desafíos",
		"challengesCount": "{{value}} desafíos"
	},
	"tts": {
		"tooltip": "Escuchar"
	},
	"commandBar": {
		"placeholder": "Buscar...",
		"input": {
			"placeholder": "Escribe un comando o busca"
		},
		"sections": {
			"quickActions": "Acciones rápidas"
		},
		"actions": {
			"changeExam": "Cambiar examen",
			"switchToDarkMode": "Cambiar a modo oscuro",
			"switchToLightMode": "Cambiar a modo claro",
			"setExamDate": "Establecer fecha del examen"
		}
	},
	"filterView": {
		"placeholder": "Buscar exámenes..."
	},
	"transcript": {
		"show": "Mostrar transcripción",
		"hide": "Ocultar transcripción"
	},
	"testDriver": {
		"appBar": {
			"logoAlt": "Logotipo de la app",
			"testNameLabel": "Nombre del examen",
			"sectionLabel": "Sección",
			"back": "Regresar",
			"pause": "Pausar",
			"menuLabel": "Más opciones"
		},
		"pteSummativeAppbar": {
			"progressBarLabel": "Progreso del examen",
			"of": "de",
			"pauseSession": "Pausar sesión",
			"timerTooltip": {
				"item": "Tiempo restante para esta pregunta",
				"section": "Tiempo restante en esta sección",
				"test": "Tiempo restante en este examen"
			}
		},
		"pteSummativeBottomAppbar": {
			"next": "Siguiente"
		},
		"progressBar": {
			"timeLeftLabel": "Tiempo restante para esta pregunta",
			"timeLeftForUnit": "Tiempo restante para esta unidad",
			"questionOf": "Pregunta {{current}} de {{total}}",
			"questionProgress": "<b>{{current}}</b> de {{total}}",
			"timesUp": "Se acabó el tiempo",
			"statusTooltips": {
				"answered": "Respondida",
				"inProgress": "En curso",
				"skipped": "Omitida",
				"notSeen": "No vista"
			}
		},
		"timeRemainingDialog": {
			"title": "Aún tienes tiempo",
			"body": "Todavía queda tiempo en esta unidad. ¿Quieres revisar tus respuestas antes de enviarlas?",
			"reviewCta": "Revisar mis respuestas"
		},
		"itemTypes": {
			"reorderParagraph": {
				"sourceTitle": "Origen",
				"answerTitle": "Tu respuesta",
				"remainingBadge": "{{count}} restantes",
				"placedBadge": "{{count}} colocados",
				"pointsBadge": "{{earned}}/{{max}} puntos",
				"emptyHint": "Arrastra aquí los párrafos del panel izquierdo"
			}
		}
	},
	"redeemCopilot": {
		"contactSupport": {
			"title": "Información de soporte",
			"emailLabel": "Email",
			"subjectLabel": "Asunto",
			"messageBodyLabel": "Cuerpo del mensaje",
			"appDetailsLabel": "Detalles de la app",
			"appNameLabel": "Nombre",
			"versionLabel": "Versión",
			"platformLabel": "Plataforma"
		},
		"chat": {
			"assistantTitle": "Asistente de soporte de {{tenantName}}",
			"fallbackTitle": "Chat",
			"betaWarning": "Este asistente de IA está en **beta**; las respuestas pueden ser ocasionalmente inexactas o incompletas.",
			"greeting": "¡Hola! 👋 ¿Tienes problemas para acceder a un producto? Estoy aquí para ayudarte. Primero, vamos a identificar el problema. ¿Cuál de las siguientes opciones describe mejor tu situación?\n\n1. Tengo un código de acceso, pero no parece funcionar.\n2. Hice una compra, pero no encuentro mi código de acceso.\n3. Debí haber recibido acceso a través de mi escuela, pero no encuentro mi código de acceso.\n4. Antes tenía acceso a un producto, pero ahora no puedo acceder a él.\n\nEscribe el número correspondiente a tu problema.",
			"input": {
				"label": "Escribe un mensaje...",
				"sendLabel": "Enviar"
			}
		},
		"accessContent": {
			"redeemedTitle": "🎉 Canjeado con éxito",
			"previouslyRedeemedTitle": "🚀 Canjeado anteriormente",
			"subtitle": "Accede a tu contenido aquí",
			"expires": "Vence: {{date}}",
			"openCta": "Abrir"
		},
		"purchases": {
			"title": "🎉 Códigos de acceso encontrados",
			"subtitle": "Canjéalos para obtener acceso a tu contenido",
			"accessCodesLabel_one": "Código de acceso",
			"accessCodesLabel_other": "Códigos de acceso",
			"moreCodes_one": "(+ {{count}} más)",
			"moreCodes_other": "(+ {{count}} más)",
			"featuresLabel": "Características",
			"redeemCta": "Canjear"
		}
	},
	"versionChecker": {
		"banner": {
			"message": "Nueva versión disponible, haz clic en actualizar para obtenerla.",
			"refreshCta": "Actualizar",
			"refreshA11yLabel": "Actualizar para obtener la nueva versión",
			"dismissTooltip": "Descartar",
			"dismissA11yLabel": "Descartar la notificación de actualización"
		}
	},
	"cme": {
		"type": "Tipo de CME",
		"chooseExportMethod": "Elegir método de exportación",
		"selectDateRange": "Seleccionar rango de fechas",
		"from": "De",
		"to": "Para",
		"sendPdfTo": "Enviar PDF a {{email}}",
		"downloadCertificate": "Descargar Certificado a PDF",
		"amaCategory1": "AMA PRA Category 1",
		"creditEarnedSubtitle": "Crédito CME Obtenido",
		"confirmYourName": "Confirma tu nombre",
		"certificateNameNotice": "Este nombre se imprimirá en tu Certificado CME.",
		"firstName": "Primer nombre",
		"lastName": "Apellido",
		"firstNamePlaceholder": "Ingresa tu primer nombre",
		"lastNamePlaceholder": "Ingresa tu apellido",
		"confirm": "Confirmar",
		"creditsEarnedTitle": "CME Obtenido",
		"creditRatioCaption": "12 Desafíos = 1 Crédito CME",
		"earned": "Obtenido",
		"available": "Disponible",
		"creditsValue": "{{count}} CME",
		"exportCertificate": "Exportar Certificado CME",
		"exportDisabledCaption": "Necesitas obtener al menos 1 crédito CME para exportar tu certificado",
		"viewDisclaimer": "Ver descargo de responsabilidad de CME"
	}
}
